<template>
  <div class="zptj project_detail">
    <mt-header title="Products Detail">
      <span slot="left" @click="() => this.$router.push('/exhibitor')">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="mintHeader"></div>
    <div class="detailContent">
      <div>
        <div class="zptjTop">
          <p>{{ list.proname_en }}</p>
          <div class="datilImg">
            <img :src="list.img_url" alt="" />
            <div @click="isCollect(list.id)">
              <img
                v-show="like1 * 1 == 1"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png"
                alt=""
              />
              <img
                v-show="like1 * 1 == 2"
                src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="abstract">
          <!-- <div>{{ list.prodetails_en }}</div> -->
          <h5>Exhibits category</h5>
          <p>{{ list.class_name_en }}</p>
          <h5>Exhibitor Name</h5>
          <p>{{ list.corpname_en }}</p>
          <h5>Add</h5>
          <p>{{ list.address_en }}</p>
          <h5>Tel</h5>
          <p>{{ list.phone }}</p>
        </div>
        <h4>Product Recommendation</h4>
        <div class="slider">
          <ul class="sliderList" ref="sliderList">
            <li
              v-for="(item, i) in xgcp.list"
              :key="i"
              @click="updateItem(item)"
            >
              <div>
                <img :src="item.img_url" alt="" />
              </div>
              <p>{{ item.corpname_en }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="footer">
      <li @click="isCollect(list.id)">
        <div>
          <img
            v-show="like1 * 1 == 1"
            src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png"
            alt=""
          />
          <img
            v-show="like1 * 1 == 2"
            src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png"
            alt=""
          />
        </div>
        <span>Favorites</span>
      </li>
      <li @click="popup">
        <div>
          <img
            src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/negotiate_1.png"
            alt=""
          />
        </div>
        <span>Enquiry</span>
      </li>
      <li @click="dakai">
        <div>
          <img
            src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/pack_1.png"
            alt=""
          />
        </div>
        <span>Contact</span>
      </li>
    </ul>

    <!-- 留言重写！！！ -->
    <div class="mask" v-if="popup2">
      <div class="popup">
        <h2>Input Your Message</h2>
        <!-- <p>Appointment Date：</p> -->
        <textarea v-model="msgConnet" placeholder="Input Your Message"></textarea>
        <div class="btn_group">
          <button @click="popup2 = false">Cancel</button>
          <button @click="reqAddCon()">Request A Meeting</button>
        </div>
      </div>
    </div>
    <div class="mask" v-if="popup1">
      <div class="popup">
        <h2>Make an Appointment</h2>
        <p>Appointment Date：</p>
        <button class="btnTime" @click=" () => { this.$refs.picker.open(); }" >
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/date.png"/>
          {{ form.date }}
        </button>
        <p>Leave a Message：</p>
        <textarea v-model="form.connet" placeholder="Input Your Message"></textarea>
        <div class="btn_group">
          <button @click="popup1 = false">Cancel</button>
          <button @click="isCorpApp(list.ocid)">Request A Meeting</button>
        </div>
      </div>
      <mt-datetime-picker
        ref="picker"
        type="date"
        year-format="{value} years"
        month-format="{value} month"
        date-format="{value} day"
        @confirm="handleChange"
      >
      </mt-datetime-picker>
    </div>
  </div>
</template>

<script>
import { Header, DatetimePicker, Toast } from "mint-ui";
import "mint-ui/lib/header/style.css";
import "mint-ui/lib/message-box/style.css";
import {
  reqDetails,
  reqExhibitList,
  reqProColl,
  reqProCollDo,
  reqCorpAppDo,
  reqAddNote,
} from "../../../api";
export default {
  components:{
    'mt-header':Header,
    'mt-datetime-picker':DatetimePicker,
  },
  data() {
    return {
      like1: 1,
      id: Number,
      ocid: Number,
      list: {},
      xgcp: {},
      form: {
        id: 0,
        date: "",
        connet: "",
      },
      popup2:false,//留言
      popup1: false,//约见
      msgConnet:'',//留言内容
    };
  },
  mounted() {
    // 截取字符串
    let id = this.$route.path.split("/");
    this.id = id[id.length - 2] * 1;
    this.ocid = id[id.length - 1] * 1;
    this.form.id = id[id.length - 1] * 1;
    this.reqDetail(this.id);
    this.initCollect(this.id);
  },
  methods: {
    // popup  弹窗  未写完
    popup(){
      // MessageBox.prompt("", "Input Your Message").then((value) => {
      //   console.log(value);
      // });
      this.popup2 = true
    },
    
    async reqAddCon() {// 询盘发送请求
      if(!this.msgConnet.trim()){
        Toast({position:'top',message:'Input Your Message'})
        return
      }
      const response = await reqAddNote(this.list.id, this.msgConnet);
      if (response.code*1 == 0) {
        Toast({position:'top',message:'Exhibitor is offline, please try again later...'})
      } else if (response.code*1 == 1) {
        this.popup2 = false;
        this.msgConnet = "";
        Toast({position:'top',message:'Send Successfully'})
      }
    },

    
    async reqDetail(id) {// 请求列表
      const response = await reqDetails(id);
      if (response.code == 0) {
        this.list = response.resilt[0];
        this.reqRelatedExh(response.resilt[0].fk_parentid);
      } else {
        this.$router.push("/");
      }
    },
    // 相关产品请求
    async reqRelatedExh(id) {
      const response = await reqExhibitList(1, id);
      if (response.code == 0) {
        this.xgcp = { list: response.resilt, name: "Related Products" };
      }
    },
    //跳转
    updateItem(item) {
      this.$router.push("/exhibit/details/" + item.id + "/" + item.ocid);
      this.reqDetail(item.id);
    },
    // 初始获取收藏状态
    async initCollect(id) {
      const response = await reqProColl(id);
      if (response.code == 0) {
        this.like1 = response.is_coll;
      } else {
        this.collect = 1;
      }
    },
    // 修改收藏状态
    async isCollect(id) {
      const response = await reqProCollDo(id);
      if (response.code == 0) {
        this.like1 = response.is_coll;
      }
    },
    dakai() {
      let time = new Date();
      this.form.date =
        time.getFullYear() + "-" + time.getMonth() + "-" + time.getDate();
      this.popup1 = true;
      this.form.connet = "";
    },
    
    async isCorpApp() {// 约见
      if (this.form.connet == "") {
        Toast({ message: "Please input your message", position: "center" });
        return;
      }
      const response = await reqCorpAppDo(this.form);
      if (response.code == 0) {
        Toast({ message: "Succeed", position: "center" });
        this.popup1=false
      }else if(response.code == 2){
        Toast({ message: "Appointment is successful", position: "center" });
        this.popup1=false
      }
    },
    handleChange(value) {
      this.form.date = this.formatDate(value);
      console.log(this.form.date); // 20170101
    },
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    },
  },
};
</script>

<style scoped>
.zptj {
  height: 100%;
  background-color: #f3f3f3;
}
.newListPage {
  height: 100%;
  background-color: white;
  overflow: hidden;
}
.mint-header {
  height: 40px;
  background-color: #008baf;
  position: relative;
  z-index: 10;
}
.detailContent {
  height: calc(100vh - 90px);
  overflow-y: auto;
}
.zptjTop {
  background-color: #008baf;
  background: url("http://www.cippe.com.cn/miniprogram/zpxqhead.jpg") no-repeat;
  background-size: 100% 100%;
  height: 300px;
  padding: 0 35px;
}
.zptjTop p {
  padding: 25px 0;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
}
.datilImg {
  position: relative;
  width: 100%;
  height: 200px;
  /* background-color: white; */
}
.datilImg div {
  position: absolute;
  right: 0;
  top: 0;
  /* font-size: 46px; */
  color: #aaa;
  width: 23px;
}
.abstract {
  padding: 0 20px;
  background-color: #ecfafe;
  box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.3);
}
.abstract > div {
  text-align: center;
  font-size: 13px;
  color: #666666;
  padding: 10px 0 20px;
}
.abstract h5 {
  font-size: 15px;
  padding-bottom: 8px;
}
.abstract p {
  color: #666666;
  padding-bottom: 20px;
}
.detailContent h4 {
  font-size: 16px;
  padding: 25px 0;
  text-align: center;
}
.slider {
  width: 100%;
  overflow: hidden;
}
.sliderList {
  margin: 0 10px;
  height: 150px;
  white-space: nowrap;
  overflow-x: auto;
}
.sliderList li {
  display: inline-block;
  width: 100px;
  margin: 0 5px;
  text-align: center;
  vertical-align: top;
}
.sliderList li:first-child {
  margin-left: 0;
}
.sliderList li div {
  width: 100px;
  height: 100px;
  overflow: hidden;
  box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: white;
}
.sliderList li p {
  white-space: pre-wrap;
  margin-top: 10px;
  padding: 0 2px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  box-shadow: 0 5px 5px 5px rgba(0, 0, 0, 0.3);
  background-color: #008baf;
}
.footer li {
  padding-top: 3px;
  list-style: none;
  width: 33%;
  border-left: 1px solid white;
  /* background-color: #f3f3f3; */
  color: white;
}
.footer li :first-child {
  border: none;
}
.footer li div {
  width: 27px;
  margin: 0 auto 2px;
}
.footer li i {
  margin: 0 auto;
  font-size: 27px;
  font-size: 27px;
  display: block;
  color: #8b8a8a;
}
.footer li .hue {
  color: #ff840c;
}
</style>
<style scoped>
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9;
}
.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  /* height: 300px; */
  background-color: white;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
}
.popup h2 {
  font-size: 14px;
  color: #008baf;
  font-weight: 600;
  line-height: 30px;
}
.popup p {
  line-height: 24px;
  padding: 6px 0;
}
.btnTime {
  text-align: left;
  width: 100%;
  padding: 6px 14px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #bbb;
  box-shadow: none;
  outline: none;
  color: #bbb;
  vertical-align: middle;
  line-height: 20px;
}
.btnTime img {
  width: 18px;
  margin-right: 10px;
  vertical-align: middle;
}
.popup textarea {
  width: 100%;
  padding: 10px;
  line-height: 20px;
  min-height: 100px;
  border: 1px solid #bbb;
}
.btn_group {
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding: 20px 0 10px;
}
.btn_group button {
  line-height: 40px;
  box-shadow: none;
  outline: none;
  border: none;
  color: #008baf;
  background-color: white;
  border: 1px solid #008baf;
  width: 40%;
  font-size: 12px;
}
.btn_group button + button {
  background-color: #008baf;
  color: white;
}
</style>